export const actions = {
    START_FETCHING_BUNDLES: "START_FETCHING_BUNDLES",
    START_FETCHING_BUNDLE_REPOSITORY: "START_FETCHING_BUNDLE_REPOSITORY",
    FETCH_BUNDLES_SUCCESSFUL: "FETCH_BUNDLES_SUCCESSFUL",
    FETCH_BUNDLES_FAILED: "FETCH_BUNDLES_FAILED",

    START_UNINSTALL_BUNDLES: "START_UNINSTALL_BUNDLES",

    START_INSTALL_BUNDLES: "START_INSTALL_BUNDLES",

    START_RELEASE_BUNDLES: "START_RELEASE_BUNDLES",

    START_PURGE_BUNDLES: "START_PURGE_BUNDLES",

    START_UNINSTALL_SINGLE_BUNDLE: "START_UNINSTALL_SINGLE_BUNDLE",

    START_INSTALL_SINGLE_BUNDLE: "START_INSTALL_SINGLE_BUNDLE",

    START_RELEASE_SINGLE_BUNDLE: "START_RELEASE_SINGLE_BUNDLE",

    START_PURGE_SINGLE_BUNDLE: "START_PURGE_SINGLE_BUNDLE",

    // Optimistic store update: drop a just-purged bundle from the cached repository
    // listing immediately, so remote-version-gated actions (Purge/Uninstall) hide
    // the moment the action completes instead of after the async re-fetch round-trip.
    REMOVE_BUNDLE_FROM_REPOSITORY_LISTING: "REMOVE_BUNDLE_FROM_REPOSITORY_LISTING",

    START_GIT_MAINTENANCE_SINGLE_BUNDLE: "START_GIT_MAINTENANCE_SINGLE_BUNDLE",

    BUNDLE_ACTION_FINISHED: "BUNDLE_ACTION_FINISHED",

    SINGLE_BUNDLE_ACTION_STARTED: "SINGLE_BUNDLE_ACTION_STARTED",
    SINGLE_BUNDLE_ACTION_FINISHED: "SINGLE_BUNDLE_ACTION_FINISHED",

    DISABLE_BUNDLE: "DISABLE_BUNDLE",
    ENABLE_BUNDLE: "ENABLE_BUNDLE",
};

export const initialState = {
    bundleFetching: false,
    bundleResponse: {},
    singleFetching: {},
    disabledBundlesData: {},
};

export default (
    state = initialState,
    { type, response, name, repositoryId, bundleId }
) => {
    switch (type) {
        case actions.START_FETCHING_BUNDLES: {
            return {
                ...state,
                bundleFetching: true,
            };
        }
        case actions.FETCH_BUNDLES_SUCCESSFUL: {
            return {
                ...state,
                bundleResponse: { ...state.bundleResponse, ...response },
            };
        }
        case actions.FETCH_BUNDLES_FAILED: {
            return {
                ...state,
            };
        }
        case actions.REMOVE_BUNDLE_FROM_REPOSITORY_LISTING: {
            const repository = state.bundleResponse[repositoryId];
            if (!repository?.bundle_list) {
                return state;
            }
            return {
                ...state,
                bundleResponse: {
                    ...state.bundleResponse,
                    [repositoryId]: {
                        ...repository,
                        bundle_list: repository.bundle_list.filter(
                            (bundle) => bundle.id !== bundleId
                        ),
                    },
                },
            };
        }
        case actions.START_UNINSTALL_BUNDLES: {
            return {
                ...state,
                bundleFetching: true,
            };
        }
        case actions.START_INSTALL_BUNDLES: {
            return {
                ...state,
                bundleFetching: true,
            };
        }
        case actions.START_RELEASE_BUNDLES: {
            return {
                ...state,
                bundleFetching: true,
            };
        }
        case actions.START_PURGE_BUNDLES: {
            return {
                ...state,
                bundleFetching: true,
            };
        }
        case actions.BUNDLE_ACTION_FINISHED: {
            return {
                ...state,
                bundleFetching: false,
            };
        }
        case actions.SINGLE_BUNDLE_ACTION_STARTED: {
            return {
                ...state,
                singleFetching: {
                    [name]: true,
                },
            };
        }
        case actions.SINGLE_BUNDLE_ACTION_FINISHED: {
            return {
                ...state,
                singleFetching: {
                    [name]: false,
                },
            };
        }

        case actions.DISABLE_BUNDLE: {
            return {
                ...state,
                disabledBundlesData: { ...state.disabledBundlesData, [name]: true },
            };
        }
        case actions.ENABLE_BUNDLE: {
            return {
                ...state,
                disabledBundlesData: { ...state.disabledBundlesData, [name]: false },
            };
        }

        default:
            return state;
    }
};
